import React, { FC } from 'react';
import { CompactFilterDialogProps } from './CompactFilterObject';

const CompactFilterDialog: FC<CompactFilterDialogProps> = ({
  values,
  onChangeValue,
  active,
}) => {
  return (
    <div className={`filterdialog`}>
      {values.map((item, idx) => (
        <label className={'filteritem'} key={idx}>
          <input
            aria-checked={active.includes(item.value)}
            type="checkbox"
            checked={active.includes(item.value)}
            value={item.value}
            id={item.value}
            name={item.value}
            onChange={() => onChangeValue(item)}
            aria-label={item.label}
          />
          <span
            className={`checkbox`}
            aria-checked={active.includes(item.value)}
          />
          {item.label}
        </label>
      ))}
    </div>
  );
};

export default CompactFilterDialog;
